import { Pipe, PipeTransform } from "@angular/core";

// Takes a percent string like '22.000%' and returns '22%'
// Rounds response numbers to two decimal points, or an given variable
// Removes all unnecessary leading 0s after decimal point if present
@Pipe({
    name: 'formattedPercentage',
    standalone: false
})
export class FormatPercentPipe implements PipeTransform {
    transform(percentString: string, decimalPlaces: number = 2): string {
        if (!percentString || percentString === 'undefined%') return '';
        percentString = percentString.replace(/[^0-9.]/g,'');
        percentString = parseFloat((+percentString).toFixed(decimalPlaces)).toString();
        return `${percentString}%`;
    }
}
